<template>
  <main class="main">
    <div class="group group--narrow-f2f">
      <h1 
        :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
        class="h1 group__title mw600">
        How would you like to
        <br class="hide-below-small">talk to your counselor?
      </h1>

      <ul class="appointment-type-list appointment-type-list--f2f">
        <li v-for="(item, index) in items" :key="index" @click="select(item.target)" class="appointment-type-list__item appointment-type-list__item--border mb">
          <div class="appointment-type-list__content appointment-type-list__content--flex">
            <h2 
              :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
              class="h2 mt0 mb-">{{ item.title }}</h2>
            <ul>
              <li
                v-for="(listItem, index) in item.listItems"
                :key="index"
                :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
                class="c-accent fw-medium"
                v-html="listItem"
              />
              <p class="mt- mb0 p fs-14 fw-medium appointment-type__info" v-if="item.target === `results`">
                Currently available for individual counseling. For family or couples counseling options, please contact us at {{ formattedNumber }}
              </p>
            </ul>
          </div>

          <div class="appointment-type-list__content appointment-type-list__content--image pa0 hide-below-medium">
            <div :class="[`appointment-type-list__image`, `appointment-type-list__image--${item.image}`]" />
          </div>
        </li>
      </ul>

      <p class="p fs-14">*For video chat, you will need a computer, tablet, or mobile phone with a camera. To speak over the phone, we’ll give you a call.</p>
    </div>
  </main>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// API
// import { HTTP } from "api/http";

// Mixins
import MixinIntakeProgress from 'components/IntakeProgress';

// Utils
import { getLastQuestionId } from 'utils/questionnaire';
import { handleF2fSelection } from 'utils/f2fSelection';
import phone from 'utils/phone';

export default {
  name: 'view-appointment-type',

  // Components
  // Props
  // Mixins
  mixins: [
    MixinIntakeProgress,
  ],

  // Data
  data() {
    return {
      items: [
        {
          title: 'Phone or video call',
          listItems: [
            'Request a phone or video appointment from a convenient location*',
            'Review your options for counselors <span class="fw-bold">here</span>',
            'Immediate and flexible appointment times are available',
            'Manage your appointment through this website',
          ],
          image: 'phone',
          f2f: false,
          target: 'results',
        },
        {
          title: 'In person',
          listItems: [
            'Request an in-person appointment at a counselor’s office',
            'Receive a call or email within 48 hours with a list of suggested counselors',
            'Call and schedule an appointment with any recommended counselors',
            'Reach back out to us with counselor’s name and appointment details',
          ],
          image: 'character',
          f2f: true,
          target: 'face-2-face',
        },
      ],
    };
  },

  // Computed
  computed: {
    ...mapGetters('questions', ['appointmentStartingQuestion']),
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapGetters('appointment', [
      'appointments',
      'f2fAppointment',
    ]),
    ...mapGetters('app', [
      'org',
    ]),

    formattedNumber() {
      return phone(this.org.phone);
    },
  },

  // Methods
  methods: {
    ...mapActions('questions', ['requestAppointmentStartingQuestion', 'selectFace2Face']),
    ...mapActions('appointment', ['createF2fAppointment']),
    ...mapActions('answers', ['requestUpdateAnswer']),

    select(target) {

      if ( target === 'results' ) {
        localStorage.setItem('howContact', JSON.stringify(this.appointmentStartingQuestion.choices));
        localStorage.setItem('appointmentStartingQuestion', this.appointmentStartingQuestion.id);
      } else {
        localStorage.removeItem('howContact');
      }

      if ( target ) {
        this.selectFace2Face(target === 'face-2-face');

        const route = {
          name: target,
        };

        if ( target === 'face-2-face' ) {
          const question = _.find(this.appointmentStartingQuestion.choices, choice => choice.next_question); // eslint-disable-line no-undef

          // Get the ID of the last answered question in the F2F questionnaire
          const lastQuestionId = getLastQuestionId('f2f');

          route.params = {
            id: lastQuestionId || question.next_question,
          };

          handleF2fSelection(); // Returns a promise, not needed here. Sets the `appointmentSelectionAnswer` in the service

        }

        this.$router.push(route);
      }
    },
  },
  // Watchers

  // Lifecycles
  created() {
    this.requestAppointmentStartingQuestion();

    if ( !this.isAuthenticated ) {
      if (
        !this.checkIntakeRequirements('default', 'intakeDetail', 2) &&
        !this.checkIntakeRequirements('default', null, null)
      ) {
        this.$router.push({ name: 'home' });

        return;
      }

      this.checkIntakeRequirements('default', 'intakeDetail', 2, 'help');
    }
  },
  // Filters
};
</script>



// WEBPACK FOOTER //
// AppointmentType.vue?2a490b5b